import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Wrapper from '../../components/wrapper'
import './styles.css'

/**
 *  CarLineupFilterItem
 */
class CarLineupFilterItem extends PureComponent {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    displayLabel: PropTypes.string,
    value: PropTypes.string,
    operator: PropTypes.string,
    formType: PropTypes.string,
    formName: PropTypes.string
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    displayLabel: null,
    value: null,
    operator: null,
    formType: null,
    formName: null
  };

  constructor(props) {
    super()
    this.props = props
    this.state = {}
  }

  render() {
    const {
      containerId,
      containerClass,
      displayLabel,
      value,
      operator,
      formType,
      formName
    } = this.props

    switch (formType) {
      case 'radio':
        return (
          <Wrapper containerId={containerId} containerClass={containerClass}>
            <div className="CarLineupFilterItem">
              <label className="CarLineupFilterItem__Label"><input type="radio" name={formName} value={value} data-operator={operator} className="CarLineupFilterItem__Label__Radio" /><span className="CarLineupFilterItem__Label__Icon" /><span className="CarLineupFilterItem__Label__Text">{displayLabel}</span></label>
            </div>
          </Wrapper>
        )
        break
      case 'checkbox':
        return (
          <Wrapper containerId={containerId} containerClass={containerClass}>
            <div className="CarLineupFilterItem">
              <label className="CarLineupFilterItem__Label"><input type="checkbox" name={formName} value={value} data-operator={operator} className="CarLineupFilterItem__Label__Checkbox" /><span className="CarLineupFilterItem__Label__Icon" /><span className="CarLineupFilterItem__Label__Text">{displayLabel}</span></label>
            </div>
          </Wrapper>
        )
        break
      case 'option':
        return (
          <option value={value} data-operator={operator} className="CarLineupFilterItem__Option">{displayLabel}</option>
        )
        break
      default:
        return (
          <Wrapper containerId={containerId} containerClass={containerClass}>
            <div className="CarLineupFilterItem">
              <label className="CarLineupFilterItem__Label"><input type="radio" name={formName} value={value} data-operator={operator} className="CarLineupFilterItem__Label__Radio" /><span className="CarLineupFilterItem__Label__Icon" /><span className="CarLineupFilterItem__Label__Text">{displayLabel}</span></label>
            </div>
          </Wrapper>
        )
    }
  }
}

export default CarLineupFilterItem



// WEBPACK FOOTER //
// ./src/containers/car-lineup-filter-item/index.jsx